// extracted by mini-css-extract-plugin
export default {"tryAgainBtn":"evaluation-menu_tryAgainBtn__EqbMd"};